// components/Navbar.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex-shrink-0 flex items-center">
            <span className="text-2xl font-bold text-[#822727]">DrinkWine</span>
          </div>
          <div className="flex space-x-4">
            <Link
              to={'/register'}
              className="bg-[#822727] text-white px-4 py-2 rounded-lg hover:bg-[#661C1C] transition-colors"
            >
              Register
            </Link>
            <Link
              to={'/login'}
              className="bg-[#822727] text-white px-4 py-2 rounded-lg hover:bg-[#661C1C] transition-colors"
            >
              Login
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;